import {ILedger} from './_model'

type Props = {
  totalContent: ILedger
}

const CustomBottomRow = ({totalContent}: Props) => {
  return (
    <>
      <tr>
        <td></td>
        <td></td>
        <td>TOTAL</td>
        <td>{totalContent.debit}</td>
        <td>{totalContent.credit}</td>
        <td>{totalContent.running_balance}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td>Closing Balance</td>
        <td></td>
        <td></td>
        <td>{totalContent.running_balance}</td>
      </tr>
    </>
  )
}

export default CustomBottomRow
